import { parseUrlFacets } from 'lib/algolia/v2'
import { observerEpicHelper } from 'epics/helpers'
import { Actions as PageActions } from 'actions/page'
import { Actions as AlgoliaDataActions } from 'actions/algolia2/data'
import { updateAppUrl } from 'lib/url/route'
import { getAlgoliaDataPaginationCurrent } from 'selectors/algolia2/data'
import { getAlgoliaQueryParams } from '../helpers'
import { DEFAULT_APP } from '../helpers/constants'
import { Actions as AppActions, Constants } from '../actions'
import Selectors from '../selectors'
import { getPageParams } from '../selectors/app'
export const updateUrlEpic = observerEpicHelper(
  [Constants.UPDATE_URL],
  async ({ action, observer, store }) => {
    const currentPage = Selectors.getPagePath({ ...store.value })

    // Update If Page has CHANGED/Different
    if (currentPage !== action.payload) {
      const href = action.payload
      const app = DEFAULT_APP
      updateAppUrl({
        app,
        href,
      })
    }

    observer.complete()
  }
)
export const clientsideTransitionsEpic = observerEpicHelper(
  [Constants.CLIENTSIDE_TRANSITION],
  async ({ action, observer, store }) => {
    const href = action.payload || ''
    observer.next(PageActions.SET_PATH(href))
    const slugifyDictionary = Selectors.getSlugifyDictionary({ ...store.value })
    const selectedFacets = parseUrlFacets({
      dictionary: slugifyDictionary,
      href,
    })
    // Lets figure out if PAGE has CHANGED, scroll to TOP
    const { page: lastPage } = getPageParams({ ...store.value })
    const newPage = getAlgoliaDataPaginationCurrent({ ...store.value })

    if (Number(lastPage) + 1 !== newPage) {
      // This has too many issues and NEED to discuss more w/ product
      // observer.next(ScrollActions.SCROLL_TO_TOP())
    }

    // Pull Query Variables ()
    const algoliaParams = getAlgoliaQueryParams(action.payload || '')
    observer.next(PageActions.SET_PARAMS(algoliaParams))
    observer.next(
      AlgoliaDataActions.SET_DATA({
        selectedFacets,
      })
    )
    observer.next(AppActions.UPDATE_ALGOLIA(algoliaParams))
    observer.complete()
  }
)
export const toggleProductViewEpic = observerEpicHelper(
  [Constants.TOGGLE_VIEW_TYPE],
  async ({ action, observer, store }) => {
    const isPubliclySearchable = Selectors.getIsPubliclySearchableSelected({ ...store.value })
    observer.next(
      AlgoliaDataActions.SET_SELECTED_FACETS({
        is_publicly_searchable: !isPubliclySearchable,
      })
    )
    // observer.next(AppActions.APPLY_SELECTED_FILTERS())
    observer.next(AppActions.UPDATE_ALGOLIA())
    observer.complete()
  }
)
export default [clientsideTransitionsEpic, toggleProductViewEpic, updateUrlEpic]